import React from 'react'
import { useLanguage } from '~components'
import { BottomBar, BottomText, BottomBtn } from '../HomeHero/styles'
import {
  PolicyContainer,
  PageHeader,
  PageTitle,
  PageSubtitle,
  TopDivider,
  BottomDivider,
  ContentContainer,
  Section,
  SectionTitle,
  SectionText,
  HighlightText,
  NormalText,
  BulletList,
  BulletItem,
  BackgroundWatermark
} from './styles'

import logoIcon from '../../../../assets/images/newimage/logo.svg'

// Reusable structural component for privacy sections
const PolicySection = ({ title, highlightDesc, normalDesc, desc, items, children }) => (
  <Section>
    <SectionTitle>{title}</SectionTitle>
    {highlightDesc && (
      <SectionText>
        <HighlightText>{highlightDesc}</HighlightText>{' '}
        <NormalText>{normalDesc}</NormalText>
      </SectionText>
    )}
    {desc && (
      <SectionText>
        <NormalText>{desc}</NormalText>
      </SectionText>
    )}
    {children}
    {items && (
      <BulletList>
        {items.map((item, i) => (
          <BulletItem key={i}>{item}</BulletItem>
        ))}
      </BulletList>
    )}
  </Section>
)

export const AccountDeletionPolicy = (props) => {
  const [, t] = useLanguage()

  return (
    <PolicyContainer>
      <PageHeader>
        <PageTitle>{t('ACCOUNT_DELETION_POLICY', 'ACCOUNT DELETION POLICY')}</PageTitle>
        <PageSubtitle>{t('ACCOUNT_DELETION_POLICY_SUBTITLE', 'How to request deletion of your Bottle Runners information.')}</PageSubtitle>
      </PageHeader>

      <TopDivider />

      <ContentContainer>
        <BackgroundWatermark img={logoIcon} />

        <PolicySection
          title={`1. ${t('INFORMATION_WE_COLLECT', 'INFORMATION WE COLLECT')}`}
          highlightDesc={t('INFORMATION_WE_COLLECT_DESC_1', 'Sonsmarthen d turtitories your tunners acole by')}
          normalDesc={t('ID_VERIFICARY_LOT', 'ID verificary fot Monscterct Regular.')}
        />

        <PolicySection
          title={`2. ${t('INFE_DORMATION_WE_COLLECT', 'INFE DORMATION WE COLLECT')}`}
          desc={t('INFE_DORMATION_WE_COLLECT_DESC', 'Userrs muce aollon gall thus muts andery to thel service.')}
        />

        <PolicySection
          title={`3. ${t('REQUEST_FORM', 'REQUEST FORM')}`}
        >
          <SectionText>
            <HighlightText>{t('INDEQUEST_FORM', 'indequest Form this undates')}</HighlightText>{' '}
            <NormalText>{t('DNE', 'dne')}</NormalText>{' '}
            <HighlightText>{t('BOTTLE_RUNNER_SYSTEM', 'Bottle Runner system')}</HighlightText>{' '}
            <NormalText>{t('OPECTUCH', 'opectuch')}</NormalText>
          </SectionText>
        </PolicySection>

        <PolicySection
          title={`4. ${t('U_AFT_INUEST_FORM', 'U. AFT INUEST FORM')}`}
          items={[
            t('ROW_HOMAGED_DESC', 'Row homaged the the pronall this souls up taree tesoriss wht dhas the pode on valelis opetest fis are canetaelly urthurs')
          ]}
        >
          <SectionText>
            <NormalText>{t('FWRAL_OPSUCE', 'fwral opsuce and is prcriter ofed at inas codbutel ts')}</NormalText>{' '}
            <HighlightText>{t('PRIVACY_EMAIL', 'privacy@bottlerunners.ca')}</HighlightText>
          </SectionText>
        </PolicySection>
      </ContentContainer>

      <BottomDivider />

      <BottomBar>
        <BottomText>{t('PLACE_AN_ORDER_FOR_DELIVERY', 'PLACE AN ORDER FOR DELIVERY')}</BottomText>
        <BottomBtn>{t('START_ORDER', 'START ORDER')}</BottomBtn>
      </BottomBar>
    </PolicyContainer>
  )
}
